import gql from 'graphql-tag';

export default gql`
  mutation ($contentId: MongoID!) {
    incrementContentViewCount(contentId: $contentId) {
      contentId
      viewCount
    }
  }
`;
